module.exports = __webpack_public_path__ + "img/01.b80f65eb.png";